import ProfilePage from './containers/ProfilePage';
import slice from './state/profile';

const reducer = slice.reducer;

export { reducer };

export default ProfilePage;
